import { render, staticRenderFns } from "./customFieldBoolean.vue?vue&type=template&id=4ec4483d&scoped=true"
import script from "./customFieldBoolean.vue?vue&type=script&lang=js"
export * from "./customFieldBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4483d",
  null
  
)

export default component.exports